module.exports = __webpack_public_path__ + "img/smarttile.291ff4bb.svg";